module.exports = __webpack_public_path__ + "img/家国-慈孝有亲.dc2e9886.png";